import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const PaymentFee = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Rules for Payment of Fee" midBreadcrumb="Rules" mainBreadcrumb="Rules for Payment of Fee" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div class="row">
                        <div class="col-12">
                            <h2 class="mainhead" >Rules for Payment of Fee</h2>
                            <h3 class="subhead">Nothing good in this world comes free! For everything there’s a payment of time or money
                                or soul!</h3>
                            <div class="row admission">
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h1 class="card-title">01</h1>
                                            <p class="card-text">The Payment of the School fees is done in the (school oﬃce)</p>
                                            <ul class="list">
                                                <li>Fees are deposited on a quarterly basis. Fees are accepted in the months of April (for quarter
                                                    April to June along with supplemenng annual charges etc.) July (for the quarter July to
                                                    September), October (for the quarter October to December), and January (for the quarter; January
                                                    March).</li>
                                                <li>The last date to deposit fee for a given Quarter is 15th of the ﬁrst month of the given Quarts
                                                    (as speciﬁed above) </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h1 class="card-title">02</h1>
                                            <p class="card-text"> If the fees are not paid within two months, the pupil's name will be deleted
                                                from the School Rolls, and re-admission will not be easily granted. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h1 class="card-title">03</h1>
                                            <p class="card-text">Once deposited, fees and other charges will not be refunded under any
                                                circumstance.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h1 class="card-title">04</h1>
                                            <p class="card-text">Failure to pay the due fee and other charges before the commencement of the
                                                examinaons may debar a student from it in all cases, the school management shall with hold the
                                                result, and the student concerned will not be eligible for promoon to the next class unless the dues
                                                are- cleared within the me spulated by the school management. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h1 class="card-title">05</h1>
                                            <p class="card-text"> A fee will also be charged for any extract from school records.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h1 class="card-title">06</h1>
                                            <p class="card-text">The school management reserves the right to modify or enhance the amount of fees
                                                and other charges annually. The said modiﬁcaon / enhancement shall become due payable with prospecve
                                                eﬀect. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="text-center"><strong>Note: </strong>For further details concerning the payment of fees, kindly refer
                                to the fee booklet</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default PaymentFee